import { Checkbox, FormContext, FormControlContainer, FormGroup, OverlayTrigger } from '@hai/ui-react';
import { FormikProps } from 'formik';
import { isNil } from 'ramda';
import React from 'react';

import { ConditionalWrapper } from './conditional-wrapper';
import { generateDataAuto } from 'src/js/util/automation';

interface Props {
  name: string;
  disabled?: boolean;
  label?: string;
  className?: string;
  checked?: boolean;
  container?: boolean;
  tooltip?: string | React.ReactNode;
  onChange?: Function;
}

export const FormCheckbox: React.FunctionComponent<Props> = ({
  name,
  disabled,
  label,
  className,
  checked,
  container = true,
  tooltip,
  onChange,
}) => {
  return (
    <FormContext.Consumer>
      {(formContext: FormikProps<any>) => {
        // If HAIUI ever handles this internally for checkbox we could remove this block of formik code
        const meta = formContext?.getFieldMeta(name);
        const helper = formContext?.getFieldHelpers(name);
        const formikValue = meta?.touched ? meta.value : meta?.initialValue;
        const onChangeLocal = (e: any) => {
          if (!isNil(name)) {
            const { checked } = e.target;
            helper?.setTouched(true);
            helper?.setValue(checked);
          }
          onChange?.(e);
        };
        return (
          <FormGroup className={className}>
            <ConditionalWrapper
              condition={container}
              wrapper={(children) => <FormControlContainer>{children}</FormControlContainer>}
            >
              <Checkbox
                name={name}
                checked={checked ?? !!formikValue}
                onChange={onChangeLocal}
                disabled={disabled}
                data-auto={generateDataAuto('checkbox', name)}
              >
                {label}
              </Checkbox>
            </ConditionalWrapper>
            {container && <div className="hai-mb-5" />}
            {tooltip != null && <div className="mk-field-tooltip"><OverlayTrigger popoverContent={tooltip} placement="top"><div className="filler">{tooltip}</div></OverlayTrigger></div>}
          </FormGroup>
        );
      }}
    </FormContext.Consumer>
  );
};
